import React, { useMemo } from "react";
import { Col, Card } from "antd";
import dayjs from "dayjs";

import QuantityBadge from "components/quantity-badge/quantity-badge";
import { Maybe, Products, Properties, Installed_Products } from "graphql/generated/graphql";
import { useLoggedUser } from "state/reactive-vars/logged-user-var";

interface ProductCardProps {
	product: Products;
	handleOnClickProduct: (id: string) => void;
	installed_product?: Installed_Products;
	entityId?: any;
	property?: Maybe<Properties> | undefined;
	installation_date?: any;
	location?: Maybe<string>;
	properties?: Properties[];
	productQuantity?: number;
	shopProduct?: boolean;
	device_status?: Maybe<string>;
}

const ProductCard: React.FC<ProductCardProps> = (props: ProductCardProps) => {
	const {
		product,
		handleOnClickProduct,
		installed_product,
		property,
		location,
		installation_date,
		entityId,
		properties,
		productQuantity,
		shopProduct = false,
		device_status
	} = props;

	const { photo_link, name, make, model, created_at, sku, retail_price } = product;

	const { loggedUserValue } = useLoggedUser();

	const imageSrc = useMemo(() => {
		if (installed_product && installed_product.photo_link) {
			return installed_product.photo_link;
		}

		return photo_link ? photo_link : "";
	}, [photo_link, installed_product]);

	return (
		<Col>
			<Card hoverable bordered={false} className="product-card" onClick={() => handleOnClickProduct(entityId)}>
				{imageSrc ? (
					<img alt={name} src={imageSrc} className={`product-image`} />
				) : (
					<div className={`product-image`}>
						<img
							alt={name}
							src={`${process.env.PUBLIC_URL}/assets/images/icons/product-placeholder.svg`}
							className={`product-image-placeholder`}
						/>
					</div>
				)}

				<div className="product-title">
					<div className="product-title-container">
						<span className="product-name">{name}</span>
					</div>

					{property ? (
						<div className="product-property-container">
							<span className="product-property-name">{property.name}</span>
						</div>
					) : null}

					{properties && properties.length ? (
						<div className="shop-product-properties-container">
							{properties.map((shop_property, index) => {
								const { name: propertyName } = shop_property || {};
								return (
									<span key={`shop-product-${entityId}-property-${index}`} className="shop-product-property-name">
										{propertyName}
									</span>
								);
							})}
						</div>
					) : null}
				</div>

				<div className="product-card-space">
					<div>
						<span className="product-description">{make}</span>
						{/online|offline/.test(String(device_status)) ? (
							<span className={`product-device-status-${device_status}`}>{device_status}</span>
						) : null}
					</div>
					<span className="product-description">{model}</span>
					{shopProduct ? null : (
						<span className="product-description">
							{installation_date
								? `Installed ${dayjs(installation_date).format("MM/DD/YYYY")}`
								: `Created ${dayjs(created_at).format("MM/DD/YYYY")}`}
						</span>
					)}

					<div className="product-bottom-container">
						<span>{location ? location : sku}</span>
						<span className="product-view-more" onClick={() => handleOnClickProduct(entityId)}>
							{"View More"}
						</span>
					</div>

					{shopProduct ? (
						<div className="shop-product-bottom-container">
							<span className="shop-product-price">
								{loggedUserValue.organization?.display_price ? retail_price : null}
							</span>
							<div style={{ position: "relative" }}>
								<div className="shop-product-card-cart-container" onClick={() => handleOnClickProduct(entityId)}>
									<img
										alt={name}
										src={process.env.PUBLIC_URL + "/assets/images/icons/header-cart-grey.svg"}
										className="shop-product-card-cart-img"
									/>
								</div>
								{productQuantity ? <QuantityBadge quantity={productQuantity} /> : null}
							</div>
						</div>
					) : null}
				</div>
			</Card>
		</Col>
	);
};

export default ProductCard;
